// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__FKU8N","overflowing":"ReadFullNote_overflowing__3jw-R"};